var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgEletronicosECelulares = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94551 0.487003C8.5262 0.236537 7.17272 1.1844 6.92222 2.60392L6.6429 4.18817L6.64278 4.18815L4.27115 17.6373L4.27173 17.6374L3.99228 19.2224C3.74183 20.6416 4.68962 21.9944 6.1092 22.2449L14.4181 23.7102C15.8374 23.9607 17.1909 23.0128 17.4414 21.5933L20.0919 6.55978L20.3713 4.97489C20.6218 3.55567 19.674 2.20284 18.2544 1.95233L9.94551 0.487003ZM19.1072 6.38614L19.3865 4.80174C19.541 3.9265 18.9565 3.09223 18.0806 2.93767L9.77178 1.47235C8.89639 1.31787 8.06154 1.90253 7.90701 2.77818L7.6278 4.36185L19.1072 6.38614ZM5.25663 17.811L16.736 19.8353L16.4566 21.4202C16.3021 22.2958 15.4672 22.8805 14.5918 22.726L6.28293 21.2607C5.40711 21.1061 4.82262 20.2719 4.97708 19.3966L5.25663 17.811ZM16.9091 18.8504L5.42962 16.8261L7.45392 5.34662L18.9334 7.37092L16.9091 18.8504ZM10.5946 21.1014C10.9771 21.1682 11.3414 20.9129 11.4089 20.5301C11.4764 20.1474 11.2204 19.783 10.8386 19.7155C10.4568 19.6479 10.0912 19.9033 10.0237 20.286C9.9569 20.6687 10.2121 21.0332 10.5946 21.1014Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgEletronicosECelulares;